/**
 * *** 使用例 ***
 * <base-tooltip
 *   placement="right"             ※表示する方向 (top | left | right | bottom | bottomStart)
 *   show="{{tooltipVisibility}}"  ※表示有無, 省略可 (default: true)
 *   show-on-hover="true"          ※要素にマウスを合わせると表示するか (false: 常に表示する), 省略可 (default: false)
 *   width="300px"                 ※tooltipの横幅(単位含む), 省略可 (default:300px)
 *   max-width="300px"             ※tooltipの最大横幅(単位含む), 省略可 (default:300px)
 * >
 *   <button>ツールチップを表示したい対象の要素</button>
 *   <div data-tooltip>ツールチップの内容 ※data-tooltip属性をつける</div>
 * </base-tooltip>
 */

angular.module('inspinia').directive('baseTooltip', function () {
  return {
    restrict: 'E',
    scope: {
      placement: '@', // 'top' | 'left' | 'right' | 'bottom'| 'bottomStart'
      show: '@',
      showOnHover: '@',
      width: '@',
      maxWidth: '@',
    },
    transclude: true,
    link: (scope) => {
      scope.placement = scope.placement || 'right';

      /**
       * CSSのクラス名を返す
       * @returns {object} tooltipの状態を示すクラス
       */
      scope.baseTooltipClasses = () => {
        const classes = ['anglrC-tooltip', `anglrC-tooltip--${scope.placement}`];

        if (scope.showOnHover && scope.showOnHover !== 'false') {
          classes.push('anglrC-tooltip--hover');
        }

        if (scope.show && scope.show === 'false') {
          classes.push('anglrC-tooltip--disabled');
        }
        return classes;
      };

      /**
       * スタイル指定を返す
       * @returns {object} tooltipの横幅(CSS変数)を含むスタイル文字列
       */
      scope.baseTooltipStyle = () => {
        // ng-styleはCSS変数に対応していないため通常のstyle属性向けに文字列で生成する
        const styles = [];
        if (scope.width) {
          styles.push(`--tooltip-width: ${scope.width};`);
        }
        if (scope.maxWidth) {
          styles.push(`--tooltip-maxWidth: ${scope.maxWidth};`);
        }
        return styles.join(' ');
      };
    },
    templateUrl: 'src/view/directive/base_tooltip.html',
  };
});
